// extracted by mini-css-extract-plugin
export default {"icon2":"MainEn_icon2__yPaY6","swiperMain":"MainEn_swiperMain__NG-1Q","ai2":"MainEn_ai2__8MIK4","p":"MainEn_p__CimGx","aiContainer":"MainEn_aiContainer__WS4AD"};